import { DropdownManager } from "./components/DropdownManager.js";

DropdownManager.use();
